import { render, staticRenderFns } from "./Customizer.vue?vue&type=template&id=67dc062c&scoped=true"
import script from "./Customizer.vue?vue&type=script&lang=js"
export * from "./Customizer.vue?vue&type=script&lang=js"
import style0 from "./Customizer.vue?vue&type=style&index=0&id=67dc062c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../routestatus/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67dc062c",
  null
  
)

export default component.exports